import QRCode from 'qrcode';

/** QR module matrix (true = dark) for a payload; short payloads produce the design's 21×21 or 25×25 grid. */
export function qrMatrix(payload: string): { size: number; cells: boolean[] } {
  const qr = QRCode.create(payload, { errorCorrectionLevel: 'L' });
  const size = qr.modules.size;
  const cells: boolean[] = [];
  for (let i = 0; i < size * size; i++) cells.push(Boolean(qr.modules.data[i]));
  return { size, cells };
}
